import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FadeIn } from './ui/FadeIn';
import { ChevronDownIcon } from 'lucide-react';
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    q: '¿Tengo que dejar el café?',
    a: 'No, aprenderás a tomarlo de forma que no dispare tu cortisol. El secreto está en el momento del día y con qué lo acompañas.'
  }, {
    q: '¿Necesito equipo de gimnasio?',
    a: 'Ninguno. Todo se basa en movimientos corporales somáticos y hábitos simples que puedes hacer en tu propia habitación.'
  }, {
    q: '¿Es una dieta keto?',
    a: 'No. Es una alimentación equilibrada enfocada en la respuesta hormonal, no en macros extremos. Tu cuerpo necesita carbohidratos correctos para sentirse seguro.'
  }, {
    q: '¿Funciona si estoy en la menopausia?',
    a: 'Especialmente ahí. Es cuando más necesitas regular el cortisol, ya que la caída de estrógenos hace que tu cuerpo sea más sensible al estrés.'
  }];
  return <section className="py-24 bg-cream" data-id="element-24">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-25">
        <FadeIn data-id="element-26">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12" data-id="element-27">
            Preguntas Frecuentes
          </h2>
        </FadeIn>

        <div className="space-y-4" data-id="element-28">
          {faqs.map((faq, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-29">
              <div className="bg-white rounded-2xl overflow-hidden border border-sage-light/50 shadow-sm" data-id="element-30">
                <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" aria-expanded={openIndex === index} data-id="element-31">
                  <span className="font-bold text-lg pr-4" data-id="element-32">{faq.q}</span>
                  <ChevronDownIcon className={`w-5 h-5 text-sage transition-transform duration-300 shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-33" />
                </button>

                <AnimatePresence data-id="element-34">
                  {openIndex === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} data-id="element-35">
                      <div className="px-6 pb-5 text-brown/70 leading-relaxed" data-id="element-36">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}